module.exports = __webpack_public_path__ + "static/img/7areaA_05.c48caec.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/7areaA_05.png
// module id = 1054
// module chunks = 1